// extracted by mini-css-extract-plugin
export default {"upperNav":"index_upperNav_hOdln","navItem":"index_navItem_xW6A3"};